import { useEffect, useRef, useState } from 'react';
import { identity } from '../content';
import { navigate } from '../Router';
import { Alerts } from './Alerts';
import { AiBots } from './AiBots';
import { Telegram } from './Telegram';
import { Subs } from './Subs';
import './Make.css';

const TABS = [
  { id: 'alerts', label: 'Alerts' },
  { id: 'aibots', label: 'AI Bots' },
  { id: 'telegram', label: 'Telegram' },
  { id: 'subs', label: 'Subscriptions' },
] as const;

type TabId = (typeof TABS)[number]['id'];

export function Make() {
  const [tab, setTab] = useState<TabId>('alerts');
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    tabRefs.current = tabRefs.current.slice(0, TABS.length);
  }, []);

  const onKey = (event: React.KeyboardEvent, index: number) => {
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % TABS.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + TABS.length) % TABS.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = TABS.length - 1;
    else return;
    event.preventDefault();
    const target = TABS[next];
    if (!target) return;
    setTab(target.id);
    tabRefs.current[next]?.focus();
  };

  return (
    <div className="mk">
      <div className="mk-wash" aria-hidden="true" />

      <header className="mk-top">
        <a
          className="mk-back"
          href="/"
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
            event.preventDefault();
            navigate('/');
          }}
        >
          <span aria-hidden="true">&#8592;</span> Back
        </a>
        <span className="mk-name">{identity.handle}</span>
      </header>

      <main className="mk-main">
        <section className="mk-intro">
          <h1 className="mk-title">What I can make</h1>
          <p className="mk-lead">
            Example of some things I have made before, and can build for your community.
          </p>
        </section>

        <div className="mk-tabs" role="tablist" aria-label="What I can make">
          {TABS.map((entry, i) => (
            <button
              key={entry.id}
              ref={(el) => {
                tabRefs.current[i] = el;
              }}
              className="mk-tab"
              role="tab"
              id={`tab-${entry.id}`}
              aria-selected={tab === entry.id}
              aria-controls={`panel-${entry.id}`}
              tabIndex={tab === entry.id ? 0 : -1}
              onClick={() => setTab(entry.id)}
              onKeyDown={(event) => onKey(event, i)}
            >
              {entry.label}
            </button>
          ))}
        </div>

        <div
          className="mk-panel"
          role="tabpanel"
          id={`panel-${tab}`}
          aria-labelledby={`tab-${tab}`}
          tabIndex={0}
        >
          {tab === 'alerts' ? <Alerts /> : null}
          {tab === 'aibots' ? <AiBots /> : null}
          {tab === 'telegram' ? <Telegram /> : null}
          {tab === 'subs' ? <Subs /> : null}
        </div>
      </main>
    </div>
  );
}
